import React  from 'react'
import { map, isPresent } from 'lodash'
import axios from 'lib/axios'
import { Formik, Form } from 'formik'
import PropTypes from 'prop-types'

import AssetNameSchema from './utilities/validation'
import FormLabel from './components/FormLabel';
import FormSelect from './components/FormSelect';
import { assetNameWorkflow, DEFAULT_ASSET_NAME_TEMPLATE } from './utilities/AssetNameGenerationWorkflow';

const LinkButtonStyles = {
  background: 'transparent',
  border: '0',
  color: '#6327d0',
  textDecoration: 'underline',
  cursor: 'pointer',
  padding: '0',
  textAlign: 'left',
  outline: 'none'
}

class AssetNameGenerator extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      assetNameTemplate: DEFAULT_ASSET_NAME_TEMPLATE,
      assetNames: [DEFAULT_ASSET_NAME_TEMPLATE],
      formState: {
        site: '',
        assetType: '',
        clientCode: '',
        uid: '',
        amountReserving: 1,
        reasonForReservation: '',
        somethingLocation: ''
      }
    }
  }

  submit = event => {
    const { formState, assetNames } = this.state
    const postData = {
      reserved_asset_name: {
        asset_names: assetNames,
        reason_for_reservation: formState.reasonForReservation
      }
    }

    AssetNameSchema
      .validate(formState)
      .then(() => {
        event.preventDefault()
        axios.post('/assets/names/reserve', postData)
          .then((response) => {
            window.location = '/assets/names/reserved'
          })
      })
      .catch((e) => { 'Formik handles errors and validations for us' })
  }

  updateAssetName = (fieldName, newValueToReplace) => {
    const { formState: prevFormState } = this.state

    assetNameWorkflow(fieldName, newValueToReplace, prevFormState)
      .then(({ formState, assetNameTemplate, assetNames }) => {
        this.setState({ formState, assetNameTemplate, assetNames })
      })
  }

  makeUidRequest = () => {
    const { assetNameTemplate, formState } = this.state

    axios.get('/assets/names/reserved', {
      headers: { Accept: 'application/json' },
      params: { asset_name: assetNameTemplate.slice(0, -3), something_location: formState.somethingLocation },
      responseType: 'json'
    }).then((response) => {
      let newUid = '001'

      if (isPresent(response.data)) {
        const takenNameCodes = _.map(response.data, name => name.slice(-3))
        const maxNameCode = _.maxBy(takenNameCodes, code => Math.abs(code))
        newUid = String(parseInt(maxNameCode) + 1).padStart(3, '0')
      }

      formState['uid'] = newUid
      this.setState({ formState }, () => this.updateAssetName('uid', newUid))
    })
  }

  onFieldChange = (fieldName, value) => {
    this.setState((prevState) => {
      const { formState } = prevState
      formState[fieldName] = value

      return { formState }
    }, () => this.updateAssetName(fieldName, value))
  }

  onAssetTypeChange = (value) => {
    this.onFieldChange('assetType', value.value)
    this.onFieldChange('somethingLocation', value.somethingLocation)
  }

  render () {
    const { formState, assetNames } = this.state
    const { locations, assetTypes, clients } = this.props
    const { submit, onFieldChange, makeUidRequest, onAssetTypeChange } = this

    return (
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        <div style={{ width: '500px', marginRight: '20px' }}>
          <Formik initialValues={formState} onSubmit={submit} validationSchema={AssetNameSchema}>
            <Form>
              <FormSelect {...{ name: 'site', options: locations,  value: formState.site,  onFieldChange }} />
              <FormSelect {...{ name: 'clientCode', options: clients, value: formState.clientCode, onFieldChange, label: 'Client' }} />
              <FormSelect {...{ name: 'assetType', options: assetTypes, value: formState.assetType, onChange: onAssetTypeChange, label: 'Asset Type' }} />
              <FormLabel {...{ name: 'amountReserving', label: 'How many assets are you building?' }}>
                <input
                  type="number"
                  id='amountReserving'
                  value={formState.amountReserving}
                  min='0'
                  onChange={e => onFieldChange('amountReserving', Math.abs(e.target.value))}
                />
              </FormLabel>
              <FormLabel {...{ name: 'uid', label: 'UID' }} >
                <button type='button' style={LinkButtonStyles} onClick={makeUidRequest}>
                  Get UID
                </button>
              </FormLabel>
              <FormLabel {...{ name: 'reasonForReservation', label: 'What is your reason to reserve these names?' }}>
                <textarea
                  id="reasonForReservation"
                  onChange={e => onFieldChange('reasonForReservation', e.target.value)}
                  cols="10"
                  rows="5"
                />
              </FormLabel>

              <button type='submit' className='button' onClick={e => submit(e)}>
                Reserve
              </button>
            </Form>
          </Formik>
        </div>

        <h2>
          Current Name{formState.amountReserving != 1 && 's'}:

          <ul style={{ listStyle: 'none', padding: 0 }}>
            {map(assetNames, name => <li>{name}</li>)}
          </ul>
        </h2>
      </div>
    )
  }
}

AssetNameGenerator.propTypes = {
  sites: PropTypes.arrayOf(PropTypes.shape),
  clients: PropTypes.arrayOf(PropTypes.shape),
  assetTypes: PropTypes.arrayOf(PropTypes.shape),
}

AssetNameGenerator.defaultProps = {
  sites: [],
  clients: [],
  assetTypes: [],
}

export default AssetNameGenerator
